import i18n from '@/assets/js/vue/i18n';

import teltonikaParams from './teltonika-params.json';
import moment from "moment";

export const teltonika = {
  parseAttributes(attributes) {
    const result = {};

    for (const teltonikaParam in teltonikaParams) {
      const param = teltonikaParams[teltonikaParam];
      if (!param || attributes[teltonikaParam] == null) {
        continue;
      }
      const key = i18n.global.t(param.translationKey ?? `generic.params-map.${param.name}`);
      const modifier = this[param.modifier];

      result[key] = modifier(attributes[teltonikaParam]);
    }

    return result;
  },

  parseParam(param, attributes, modifier = null) {
    if (attributes[param] === undefined) {
      return null;
    }

    if (!modifier) {
      modifier = teltonikaParams[param].modifier;
    }
    else if (typeof modifier === 'function') {
      return modifier(attributes[param]);
    }

    return this[modifier](attributes[param]);
  },

  rawValue(value) {
    return value;
  },

  percent(value) {
    return `${value} %`;
  },

  round2(value) {
    return (value).toFixed(2);
  },

  onOff(value) {
    return value === 1 ? i18n.global.t('generic.on') : i18n.global.t('generic.off');
  },

  multiplierHundreds(value) {
    return (value * 0.01).toFixed(0);
  },

  number(value) {
    return value.toFixed(0);
  },

  dateTime(value) {
    if (value) {
      return moment(value).format(i18n.global.t('settings.generic.date-time-format-moment'));
    }

    return '-';
  },

  yesNo(value) {
    return value ? i18n.global.t('generic.yes') : i18n.global.t('generic.no');
  },

  gpsSleepMode(value) {
    switch (value) {
      case 0:
        return i18n.global.t('generic.params-map.sleep-mode.no-sleep');
      case 1:
        return i18n.global.t('generic.params-map.sleep-mode.gps-sleep');
      case 2:
        return i18n.global.t('generic.params-map.sleep-mode.deep-sleep');
      case 3:
        return i18n.global.t('generic.params-map.sleep-mode.online-sleep');
      case 4:
        return i18n.global.t('generic.params-map.sleep-mode.ultra-sleep');
      default:
        return '-';
    }
  },

  batteryCurrentThousandsA(value) {
    return (value).toFixed(2) + ' V';
  },

  temperatureInC(value) {
    return `${value} °C`;
  },

  speedInKmph(value) {
    return value.toFixed(2) + i18n.global.t('generic.kmph');
  },
};
